<mat-card
  class="card"
  [ngStyle]="getStyles()"
  (click)="cardOnClick()"
  [ngClass]="getClassName()"
>
  <mat-card-content>
    <ng-content select=".card-content" id="select-content"></ng-content>
  </mat-card-content>
</mat-card>
